import React from 'react'
import {
    Avatar,
    Box,
    Link,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import { InfoItem } from './InfoTab'
import { logToAnalytics } from 'services/swMessenger'

const useStyles = makeStyles({
    pdfLogo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '40px',
        height: '40px',
        color: '#828282',
        backgroundColor: '#ededed',
        fontWeight: 'bold',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '14px',
    },
    primary: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%',
    },
    link: {
        fontFamily: 'Roboto, sans-serif !important',
        textDecoration: 'underline !important',
        color: '#212121 !important',
        fontSize: '16px !important',
        '&:visited': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:hover': {
            color: '#166ABC !important',
        },
        '&:active': {
            color: '#145EA8 !important',
        },
    },
    linkWrapper: {
        minWidth: 0,
        height: '40px',
        display: 'flex',
        alignItems: 'center',
    },
})

type Props = {
    item: InfoItem
    isLink?: boolean
}

export const InfoListItem = ({ item: { name, url }, isLink }: Props) => {
    const classes = useStyles()

    const handleClick = () => {
        logToAnalytics('playbook_info_item_clicked')
        window.open(url)
    }

    const isPdf = name?.endsWith('pdf')

    return (
        <ListItem button={!isLink as any} onClick={handleClick}>
            {!isLink && (
                <ListItemAvatar>
                    {isPdf ? (
                        <Box className={classes.pdfLogo}>PDF</Box>
                    ) : (
                        <Avatar variant="square" src={url} alt="img" />
                    )}
                </ListItemAvatar>
            )}
            {isLink ? (
                <Box className={classes.linkWrapper}>
                    <Link
                        title={url}
                        href={url}
                        target="_blank"
                        className={clsx(classes.primary, classes.link)}
                        underline="hover"
                    >
                        {name ?? url}
                    </Link>
                </Box>
            ) : (
                <ListItemText
                    primary={name ?? url}
                    classes={{
                        primary: classes.primary,
                    }}
                />
            )}
        </ListItem>
    )
}
